/**
 * Customer Service
 * Handles customer management API calls
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { CUSTOMER_ENDPOINTS, buildQueryString } from '../endpoints';

const customerService = {
  getCustomers: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${CUSTOMER_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getCustomerById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(CUSTOMER_ENDPOINTS.GET_BY_ID(id))
    );
  },

  createCustomer: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(CUSTOMER_ENDPOINTS.CREATE, data)
    );
  },

  updateCustomer: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(CUSTOMER_ENDPOINTS.UPDATE(id), data)
    );
  },

  deleteCustomer: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(CUSTOMER_ENDPOINTS.DELETE(id))
    );
  },

  getCustomerLocations: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(CUSTOMER_ENDPOINTS.LOCATIONS(id))
    );
  },
};

export default customerService;
